import React, { useMemo } from "react";
import { useRewardItemsUIContext } from "./RewardItemsUIContext";

export function RewardItemsGrouping() {
  // RewardItems UI Context
  const rewardItemsUIContext = useRewardItemsUIContext();
  const rewardItemsUIProps = useMemo(() => {
    return {
      ids: rewardItemsUIContext.ids,
      openDeleteRewardItemsDialog: rewardItemsUIContext.openDeleteRewardItemsDialog,
      openFetchRewardItemsDialog: rewardItemsUIContext.openFetchRewardItemsDialog,
    };
  }, [rewardItemsUIContext]);

  return (
    <div className="form">
      <div className="row align-items-center form-group-actions margin-top-20">
        <div className="col-xl-12">
          <div className="form-group form-group-inline">
            <div className="form-label form-label-no-wrap">
              <label className="font-bold font-danger mt-5">
                <span>Selected records count: {rewardItemsUIProps.ids.length}</span>
              </label>
            </div>
            <div className="form-group-inline">
              <button
                type="button"
                className="btn btn-danger font-weight-bolder font-size-sm"
                onClick={rewardItemsUIProps.openDeleteRewardItemsDialog}
              >
                <i className="fa fa-trash"></i> Delete All
              </button>
              &nbsp;
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
